import styled from "styled-components";
import { SIDEBAR_W } from "../../config/layout";

export const Layout = styled.div`
  display: flex;
  min-height: 100vh;
  background: #e8f2f7;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
`;

export const Main = styled.main`
  margin-left: ${SIDEBAR_W};
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

/* Completa hacia la derecha la banda blanca del logo de la sidebar */
export const TopBar = styled.header`
  height: 68px;
  flex-shrink: 0;
  background: #fff;
  border-bottom: 1px solid #e0e8f0;
`;

export const Content = styled.div`
  padding: 28px 32px;
  display: flex;
  justify-content: center;
`;

/* Se centra respecto a la ventana completa, no al área de contenido: el margen
   derecho equivale al ancho de la barra lateral, y al centrar la caja con su
   margen el bloque visible queda desplazado media barra a la izquierda.
   El título se alinea con el borde izquierdo de la tarjeta, como el diseño. */
export const CenterColumn = styled.div`
  width: 100%;
  max-width: 600px;
  margin-right: ${SIDEBAR_W};

  @media (max-width: 1100px) {
    margin-right: 0;
  }
`;

export const PageTitle = styled.h1`
  color: #1b6b78;
  font-size: 1.9rem;
  font-weight: 700;
  margin: 0 0 24px;
`;

export const Card = styled.div`
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.07);
  padding: 26px 30px;
`;

export const UserRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
`;

export const UserAvatar = styled.img`
  width: 62px;
  height: 62px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
`;

export const UserName = styled.p`
  margin: 0;
  font-size: 1.05rem;
  color: #333;

  strong { color: #1b2b3a; font-weight: 700; }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px 30px;

  @media (max-width: 620px) {
    grid-template-columns: 1fr;
  }
`;

export const FieldItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const FieldLabel = styled.span`
  font-size: 0.85rem;
  color: #55606b;
`;

export const FieldValue = styled.span`
  font-size: 0.92rem;
  font-weight: 700;
  color: #1b2b3a;
  word-break: break-word;
`;

export const ActionRow = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 28px;
`;

export const EditButton = styled.button`
  padding: 10px 22px;
  border-radius: 7px;
  border: none;
  background: #1b6b78;
  color: #fff;
  font-size: 0.88rem;
  cursor: pointer;

  &:hover { background: #175a65; }
  &:disabled { background: #8b8b8b; cursor: not-allowed; }
`;
